import React from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import "./JobLinksSection.css";

function getGlobalMode() {
  // Try to detect global mode from localStorage or body class
  if (typeof window !== 'undefined') {
    if (localStorage.getItem('darkMode') === 'true') return 'dark';
    if (document.body.classList.contains('dark-mode')) return 'dark';
  }
  return 'light';
}


function JobLinksSection() {
  const { jobLinks, loading } = useGlobalData();
  const [globalMode, setGlobalMode] = React.useState(getGlobalMode());

  React.useEffect(() => {
    const syncMode = () => setGlobalMode(getGlobalMode());
    window.addEventListener('storage', syncMode);
    window.addEventListener('darkModeChanged', syncMode);
    return () => {
      window.removeEventListener('storage', syncMode);
      window.removeEventListener('darkModeChanged', syncMode);
    };
  }, []);

  const displayRows = (jobLinks || []).filter((row) => row?.text);

  if (loading) return null;
  if (displayRows.length === 0) {
    return null;
  }

  // Helper to get effective mode for a row
  const getRowMode = (row) => {
    if (row.forceMode === 'light') return 'light';
    if (row.forceMode === 'dark') return 'dark';
    return globalMode;
  };

  return (
    <div className="job-links-section">
      {displayRows.map((row, index) => {
        const rowMode = getRowMode(row);
        let spanClass = "job-link-text";
        let colorStyle = {};
        // Logic for color based on forceMode and globalMode
        if (row.forceMode === 'light') {
          if (globalMode === 'light') {
            colorStyle.color = row.color || '#222222';
          } else {
            colorStyle.color = '#fff'; // dark mode: white
          }
        } else if (row.forceMode === 'dark') {
          if (globalMode === 'dark') {
            colorStyle.color = row.color || '#222222';
          } else {
            colorStyle.color = '#000'; // light mode: black
          }
        } else {
          // global: always use selected color
          colorStyle.color = row.color || '#222222';
        }
        // Font size from admin (default 15)
        colorStyle.fontSize = (row.fontSize || 15) + 'px';
        return (
          <p key={index} className="job-link">
            <span
              className={spanClass}
              style={colorStyle}
              data-row-mode={rowMode}
            >
              {row.text}
            </span>
          </p>
        );
      })}
    </div>
  );
}

export default JobLinksSection;
